import ChooseYourColors from "./ChooseYourColors";
import NotificationList from "./WorkspaceBannerNotifications/NotificationList";

const SiteThemeAndStyles = () => {
  return (
    <div>
      <NotificationList />
      <ChooseYourColors />
    </div>
  );
};

export default SiteThemeAndStyles;
